require('dotenv/config')

const config = {
    NETWORK: process.env.REACT_APP_ENVIRONMENT === "production" ? "polygon-mainnet" : "polygon-mumbai",
    BLOK_CONTRACT: process.env.REACT_APP_ENVIRONMENT === "production" ? '0x229b1b6c23ff8953d663c4cbb519717e323a0a84' : '0x9A9f2CCfdE556A7E9Ff0848998Aa4a0CFD8863AE',
    BLOK_POOL_CONTRACT: process.env.REACT_APP_BLOK_POOL_CONTRACT || '0xA7d480616D61382376982f5b41B373516CA272D4',
    INFURA_PROJECT_ID: process.env.REACT_APP_INFURA_PROJECT_ID || 'd5d58aea34ab46368c5b31a37d500620',
}

export default config;
